// removed by extract-text-webpack-plugin
module.exports = {"body":"fzTD","text":"_1dTh"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Modal/MessageModal/MessageModal.scss
// module id = 6fb1
// module chunks = 0